import { render } from "./ReportResult.vue?vue&type=template&id=32e3ff26&scoped=true&ts=true"
import script from "./ReportResult.vue?vue&type=script&lang=ts"
export * from "./ReportResult.vue?vue&type=script&lang=ts"

import "./ReportResult.vue?vue&type=style&index=0&id=32e3ff26&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e3ff26"]])

export default __exports__